"use client";
import { jsx as o, jsxs as I } from "react/jsx-runtime";
import { focusOutline as x } from "../../common/styles/mixins/focusOutline.js";
import $ from "../icon/Icon.js";
import { css as b } from "@emotion/react";
import i from "@emotion/styled";
import { COLORS as f } from "../../tokens/colors/Colors.js";
import { FONT_SIZES as k } from "../../tokens/font-sizes/FontSizes.js";
import { SPACINGS as h } from "../../tokens/spacings/Spacings.js";
import { forwardRef as L, Fragment as O } from "react";
const v = L(
  ({ feSize: r = "md", ...e }, y) => {
    const { feType: n } = e, c = n === "interactive", S = c ? e.ariaCurrentLabel : void 0, B = r === "sm" ? F : $, s = e.feItems;
    return /* @__PURE__ */ o(
      N,
      {
        ...e,
        "aria-label": n === "interactive" ? e["aria-label"] ?? "Breadcrumbs" : void 0,
        as: n === "static" ? "div" : void 0,
        "data-comp": "breadcrumbs",
        feSize: r,
        ref: y,
        children: /* @__PURE__ */ o(R, { children: s.map((l, m) => {
          const d = m === s.length - 1, t = l, u = c ? t.href : void 0, g = (a, C) => {
            var p;
            t.onClick && a.preventDefault(), (p = t.onClick) == null || p.call(t, a, C);
          };
          return /* @__PURE__ */ I(j, { stCurrent: d, children: [
            c ? /* @__PURE__ */ o(
              D,
              {
                "aria-current": d ? S : void 0,
                href: u,
                onClick: u ? (a) => g(a, u) : void 0,
                stCurrent: d,
                children: l.label
              }
            ) : /* @__PURE__ */ o(O, { children: l.label }),
            m !== s.length - 1 && /* @__PURE__ */ o(B, { feIcon: "chevronRight", feSize: "lg", children: "/" })
          ] }, m);
        }) })
      }
    );
  }
);
v.displayName = "Breadcrumbs";
const _ = v, N = i.nav(
  ({ feSize: r }) => b`
		font-size: ${r === "sm" && k.sm};
	`
), R = i.ol`
	display: flex;
	gap: ${h.xxs};
`, j = i.li(
  ({ stCurrent: r }) => b`
		align-items: center;
		color: ${r ? f.black : f.gray700};
		display: inherit;
	`
), D = i.a(
  ({ stCurrent: r }) => b`
		color: ${r ? "inherit" : f.brand};
		text-decoration: none;

		&:hover,
		&:focus,
		&:active {
			color: inherit;
		}

		&:focus-visible {
			${x()}
		}
	`
), F = i.span`
	margin-inline-start: ${h.xxs};
`;
export {
  _ as default
};
